// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetPreferredPackageVersionResponse } from '@digitalasset/json-api-ts-client/index';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PackageName } from '../../config/package';
import { useLedgerApiClient } from '../../contexts/LedgerApiContext';
import { useParties } from '../../contexts/PartiesContext';

export const useGetPreferredPackageVersion: (
  packageName: PackageName,
) => UseQueryResult<GetPreferredPackageVersionResponse, string> = (packageName: PackageName) => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryPreferredPackageVersion', ledgerApi, operator, packageName],
    // eslint-disable-next-line @tanstack/query/no-void-query-fn -- intentionally returns undefined when no package found
    queryFn: async () => ledgerApi.getPreferredPackageVersion(packageName, operator),
    refetchInterval: false,
  });
};
